var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B805F7",
    d: "M6.429 9h2.143A.43.43 0 0 1 9 9.43v2.143H6.857a.43.43 0 0 1-.428-.429zM18 9h-2.143a.43.43 0 0 0-.428.429v2.143h2.143a.43.43 0 0 0 .428-.429zm-8.57.43A.43.43 0 0 1 9.857 9h1.715a.43.43 0 0 1 .428.43v1.714a.43.43 0 0 1-.428.429H9.857a.43.43 0 0 1-.428-.429z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4D70D",
    d: "M6.429 12.429A.43.43 0 0 1 6.857 12h1.715a.43.43 0 0 1 .428.43v1.714a.43.43 0 0 1-.428.429H6.857a.43.43 0 0 1-.428-.429zm9 0a.43.43 0 0 1 .428-.429h1.715a.43.43 0 0 1 .428.429v1.714a.43.43 0 0 1-.428.429h-1.715a.43.43 0 0 1-.428-.429zm-3 3a.43.43 0 0 1 .428-.429h1.715a.43.43 0 0 1 .428.429v1.714a.43.43 0 0 1-.428.429h-1.715a.43.43 0 0 1-.428-.429zm-3 0A.43.43 0 0 1 9.857 15h1.715a.43.43 0 0 1 .428.429v1.714a.43.43 0 0 1-.428.429H9.857a.43.43 0 0 1-.428-.429z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B805F7",
    d: "M12.429 9.429A.43.43 0 0 1 12.857 9h1.715a.43.43 0 0 1 .428.43v1.714a.43.43 0 0 1-.428.429h-1.715a.43.43 0 0 1-.428-.429z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4D70D",
    d: "M6.429 15.429A.43.43 0 0 1 6.857 15H9v2.143a.43.43 0 0 1-.428.429H6.857a.43.43 0 0 1-.428-.429z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B805F7",
    d: "M14.884 5.872a.36.36 0 0 1 0 .527L13.5 7.715l-1.384-1.316a.36.36 0 0 1 0-.523l1.106-1.054a.407.407 0 0 1 .557 0l1.105 1.054z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4D70D",
    d: "m12 5.576l-.313.3a.36.36 0 0 0 0 .523l.313.3l-1.071 1.016l-1.385-1.316a.36.36 0 0 1 0-.523l1.106-1.054a.407.407 0 0 1 .557 0zm6 9.853a.43.43 0 0 0-.428-.429h-2.143v2.143a.43.43 0 0 0 .428.429h1.715a.43.43 0 0 0 .428-.429z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurse);
export default __webpack_public_path__ + "static/media/purse.183528e318e0a344b123840f36f54943.svg";
export { ForwardRef as ReactComponent };